const HINT_SELECTOR = ".error-text.charleft"

function toggleHint(textarea: HTMLTextAreaElement, isLimitReached: boolean): void {
    const container = textarea.parentElement
    const hint = container?.querySelector<HTMLElement>(HINT_SELECTOR)
    if (!container || !hint) {
        return
    }

    container.classList.toggle("error", isLimitReached)
    hint.style.display = isLimitReached ? "" : "none"
}

export function updateMaxLengthHint(textarea: HTMLTextAreaElement): void {
    if (textarea.maxLength < 0) {
        return
    }

    toggleHint(textarea, textarea.value.length >= textarea.maxLength)
}

export function initMaxLengthHint(textarea: HTMLTextAreaElement | null): void {
    if (!textarea || "maxLengthHintInitialized" in textarea.dataset) {
        return
    }
    textarea.dataset.maxLengthHintInitialized = ""

    textarea.addEventListener("input", () => updateMaxLengthHint(textarea))
    textarea.form?.addEventListener("reset", () => toggleHint(textarea, false))
}
